<template>

  <div class="Kv">

    <div class="one" :class="{'animated fadeIn fast ':Kvisual.one,'animated fadeOut faster':!Kvisual.one}">

    </div>
    <div class="two" :class="{'animated fadeIn fast ':Kvisual.two,'animated fadeOut faster':!Kvisual.two}">

    </div>
    <div class="three" :class="{'animated fadeIn fast ':Kvisual.three,'animated fadeOut faster':!Kvisual.three}">

    </div>
    <div class="four" :class="{'animated fadeIn fast ':Kvisual.four,'animated fadeOut faster':!Kvisual.four}">

    </div>
    <div class="five" :class="{'animated fadeIn fast ':Kvisual.five,'animated fadeOut faster':!Kvisual.five}">

    </div>

  </div>


</template>

<script>

// 顯示順序：0 瓦里安介紹 / 1 放射治療 / 2 精準放射治療 / 3 適應性治療 / 4 質子治療
const KVKEYS = ['one', 'two', 'three', 'four', 'five']

export default {
  name: 'HelloWorld',
  props: {
    Target: Number
  },
  data () {
    return {
      Kvisual: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
      },
    }
  },
  watch: {
    Target: function () {
      this.TargetSet(this.Target)
    }
  },
  mounted () {

    this.TargetSet(this.Target)
  },
  methods: {
    TargetSet (t) {
      KVKEYS.forEach((k, i) => {
        this.Kvisual[k] = i === t
      })
    },
    Goin (v) {
      alert(v)
      switch (v) {
        case 0:
          this.$router.push('/About')
          break
        case 1:
          this.$router.push('/Radiation')
          break
        case 2:
          this.$router.push('/Technology')
          break
        case 3:
          this.$router.push('/Adaptive')
          break
        case 4:
          this.$router.push('/Proton')
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .blueIn{
    filter: blur(0px);
    -webkit-filter: blur(0px);
    -moz-filter: blur(0px);
    -o-filter: blur(0px);
    -ms-filter: blur(0px);
    opacity: 1;
    animation: blur 0.5s ease-in 0s ;
    -webkit-animation: blur 0.5s ease-in 0s ;
    -moz-animation: blur 0.5s ease-in 0s ;
  }
  @keyframes blur {
    10% {
      -webkit-filter: blur(10px);
      -moz-filter: blur(10px);
      -o-filter: blur(10px);
      -ms-filter: blur(10px);
    }
  }
  .Bigbtn {
    position: relative;
    width: 300px;
    height: 300px;
    background-image: url("../assets/gobtn.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .Kv {

    position: absolute;
    /*height: 1080px;*/
    /*width: 1920px;*/
  }

  .one {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 1080px;
    width: 1920px;
    background-image: url("../assets/k01.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .two {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 1080px;
    width: 1920px;
    background-image: url("../assets/k02.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .three {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 1080px;
    width: 1920px;
    background-image: url("../assets/k03.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .four {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 1080px;
    width: 1920px;
    /* TODO: 換成 k05.png，目前沿用 k03.png 佔位 */
    background-image: url("../assets/k05.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .five {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 1080px;
    width: 1920px;
    background-image: url("../assets/k04.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

</style>
